import React from'react';

interface ProcessSectionProps {}

const ProcessSection = ({}: ProcessSectionProps) => {
  const steps = [
    {
      number: "01",
      title: "Create Contract",
      description: "Client & Provider define milestones, amounts and approval conditions on the blockchain."
    },
    {
      number: "02",
      title: "Lock Funds",
      description: "Client deposits funds into the smart contract. Funds are locked - not held by AverPact."
    },
    {
      number: "03",
      title: "Execute & Deliver",
      description: "Provider completes the milestone work. Documents uploaded as proof of delivery."
    },
    {
      number: "04",
      title: "Multi-Party Approval",
      description: "Both parties approve completion. Multi-sig ensures mutual accountability."
    },
    {
      number: "05",
      title: "Auto-Release",
      description: "Funds automatically released to Provider upon approval. Recorded on-chain."
    },
    {
      number: "06",
      title: "Dispute (if needed)",
      description: "Either party can open a dispute. Arbitrator resolves with configurable fund split."
    },
  ]

  return (
    <section id="process" className="w-full bg-white py-12 sm:py-16 lg:py-20">
      <div className="w-full max-w-[1200px] mx-auto px-4 lg:px-8">
        <div className="flex flex-col items-center gap-10 lg:gap-14 w-full">
          {/* Header */}
          <div className="flex flex-col items-center gap-3 w-full max-w-[700px]">
            <h2 className="text-[22px] sm:text-[28px] md:text-[32px] lg:text-[40px] font-semibold leading-snug text-center text-[#141A23] font-poly">
              HOW IT WORKS
            </h2>
            
            <p className="text-sm sm:text-base font-normal leading-relaxed text-center text-[#141A237f] font-dm w-full">
              Contracts are split into milestones. Funds are locked on-chain - not held by AverPact, not held by a bank. When both parties approve milestone completion, funds release automatically. Every deposit, approval, and release is immutably recorded on the blockchain.
            </p>
          </div>

          {/* 6-Step Process */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 w-full">
            {steps.map((step) => (
              <div key={step.number} className="flex flex-col gap-4 p-5 sm:p-6 bg-white rounded-xl border border-[#141A231e] hover:border-[#FF3333] transition-all duration-300">
                {/* Step Number */}
                <div className="flex items-center gap-3">
                  <span className="text-3xl sm:text-4xl font-bold text-[#FF3333] font-poly opacity-40">
                    {step.number}
                  </span>
                  <div className="flex-1 h-px bg-gradient-to-r from-[#FF333330] to-transparent"></div>
                </div>
                
                {/* Content */}
                <div className="flex flex-col gap-2">
                  <h3 className="text-base sm:text-lg font-semibold leading-snug text-[#141A23] font-poly">
                    {step.title}
                  </h3>
                  <p className="text-sm sm:text-base font-normal leading-relaxed text-[#141A237f] font-dm">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProcessSection
